module.exports = __webpack_public_path__ + "static/media/eco1.64697274.png";